export default __webpack_public_path__ + "static/img-1-9ee08394d56b70df537fd2e87df9d744.png";